import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./_WorkflowTarefa.less";
import moment from "moment";
import useFormatter from "../../hooks/useFormatter";

import { CheckSquareOutlined, ClockCircleOutlined, PaperClipOutlined, UserOutlined } from "@ant-design/icons";
import WorkflowTarefaInfoTag from "../../pages/workflows/_WorkflowTarefaInfoTag";
import WorkflowTipoTarefaTag from "../../pages/workflows/_WorkflowTipoTarefaTag";
import { Dropdown, Menu, Popconfirm, message } from "antd";
import WorkflowButton from "../../pages/workflows/_WorkflowButton";
import { useTranslation } from "react-i18next";
import { arquivarWorkflowTarefa, fetchWorkflowTarefa, removeWorkflowTarefa, selectWorkflowTarefaId } from "../../store/workflow";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";

export default function WorkflowTarefaDrawer(props) {
  const { nome, dataPrazo, dataArquivamento, dataEntrega, tipoTarefa, anexos = [], itens = [], membros = [], workflowId, id, onRefresh } = props;
  const { formatDate } = useFormatter();
  const { t } = useTranslation();
  const now = moment();
  const dispatch = useDispatchWithResult();

  const handleExcluir = async () => {
    await unwrapAxiosPromise(dispatch(removeWorkflowTarefa({ workflowId, id, refetch: false })));
    if (onRefresh) onRefresh();
  };

  const handleArquivar = async () => {
    const data = dataArquivamento ? null : new Date().toISOString();
    await unwrapAxiosPromise(dispatch(arquivarWorkflowTarefa({ workflowId, id, dataArquivamento: data, refetch: false })));
    onRefresh();
  };

  const itensMarcados = itens.filter((item) => item.itens);

  const statusPrazo = useMemo(() => {
    if (!dataPrazo || dataEntrega) return undefined;

    const prazoData = moment(dataPrazo).startOf("day");
    const hoje = moment().startOf("day");
    const diffDays = prazoData.diff(hoje, "days");

    if (diffDays < 0) return "error";
    if (diffDays <= 7) return "warning";
    return undefined;
  }, [dataPrazo, dataEntrega]);

  const statusItens = useMemo(() => {
    if (itensMarcados.length === itens.length) return "success";
  }, [itensMarcados, itens]);

  return (
    <div className={styles["workflow-tarefa"]} onClick={props.onClick}>
      <div className={styles["conteudo"]}>
        <div className={styles["cabecalho"]}>
          {tipoTarefa && <WorkflowTipoTarefaTag {...tipoTarefa} />}

          {/* <div className={styles["menu"]}>
            <Dropdown
              trigger="click"
              overlay={
                <Menu>
                  <Menu.Item key="1" onClick={props.onClick}>
                    {t("Abrir Tarefa")}
                  </Menu.Item>

                  <Menu.Item key="2">
                    <Popconfirm title={t("Você quer mesmo excluir?")} okText={t("Sim")} cancelText={t("Não")} onConfirm={handleExcluir}>
                      <span>{t("Excluir Tarefa")}</span>
                    </Popconfirm>
                  </Menu.Item>

                  {!dataArquivamento && (
                    <Menu.Item key="3">
                      <Popconfirm title={t("Você quer mesmo arquivar?")} okText={t("Sim")} cancelText={t("Não")} onConfirm={handleArquivar}>
                        <span>{t("Arquivar Tarefa")}</span>
                      </Popconfirm>
                    </Menu.Item>
                  )}
                </Menu>
              }
            >
              <div>
                <WorkflowButton title="..." />
              </div>
            </Dropdown>
          </div> */}
        </div>

        <div>{nome}</div>

        <div className={styles["informacoes"]}>
          {!!dataPrazo && <WorkflowTarefaInfoTag icon={<ClockCircleOutlined />} status={statusPrazo} text={formatDate(dataPrazo)} />}
          {!!dataEntrega && <WorkflowTarefaInfoTag icon={<CheckSquareOutlined />} text={formatDate(dataEntrega)} />}
          {anexos.length > 0 && <WorkflowTarefaInfoTag icon={<PaperClipOutlined />} text={anexos.length} />}
          {itens.length > 0 && <WorkflowTarefaInfoTag icon={<CheckSquareOutlined />} status={statusItens} text={itensMarcados.length + "/" + itens.length} />}
        </div>

        <div className={styles["membros"]}>
          {membros.map((membro) => (
            <WorkflowTarefaInfoTag key={membro.id} icon={<UserOutlined />} text={membro.nome} />
          ))}
        </div>
      </div>
    </div>
  );
}

WorkflowTarefaDrawer.propTypes = {
  id: PropTypes.number,
  etapa: PropTypes.any,
  nome: PropTypes.string,
  descricao: PropTypes.string,
  posicao: PropTypes.number,
  dataPrazo: PropTypes.string,
  dataEntrega: PropTypes.string,
  dataArquivamento: PropTypes.string,
  tipoTarefa: PropTypes.object,
  membros: PropTypes.array,
  anexos: PropTypes.array,
  itens: PropTypes.array,
};
